export enum SchoolStatusEnum {
  // Pending Participation
  SS_PP = "SS_PP",
  // Participating
  SS_Pa = "SS_Pa",
  // Not Participating
  SS_NP = "SS_NP",
  // Not Participating - Pre-Deactivation
  SS_PD = "SS_PD",
  // Not Participating - Admin Deactivated
  SS_AD = "SS_AD",
  // Inactive
  SS_IA = "SS_IA",
}

export enum PaymentStatusEnum {
  // Pending
  PS_E = "PS_E",
  // Processing
  PS_P = "PS_P",
  // Successful
  PS_S = "PS_S",
  // Success with warning
  PS_W = "PS_W",
  // Unsuccessful
  PS_U = "PS_U",
  // Cancelled
  PS_C = "PS_C",
}

export enum PaymentTypeEnum {
  // Scheduled Payment
  PT_SP = "PT_SP",
  // Manual Payment
  PT_MP = "PT_MP",
  // Manual Refund
  PT_MR = "PT_MR",
}

export enum PaymentSourceTypeEnum {
  // Credit Card
  PST_CC = "PST_CC",
  // Bank Account
  PST_BA = "PST_BA",
}

export enum FundingRequestStatusEnum {
  // Draft
  FRS_Dra = "FRS_Dra",
  // Principal Revision Requested
  FRS_PRR = "FRS_PRR",
  // Awaiting Prinicpal Review
  FRS_APR = "FRS_APR",
  // HAF Request Revision
  FRS_HRR = "FRS_HRR",
  // Pending HAF Approval
  FRS_PHA = "FRS_PHA",
  // Principal Rejected
  FRS_PRj = "FRS_PRj",
  // HAF Rejected
  FRS_HRj = "FRS_HRj",
  // Approved
  FRS_App = "FRS_App",
  // Generating
  FRS_Gtg = "FRS_Gtg",
  // Generated
  FRS_Gtd = "FRS_Gtd",
  // Submitted
  FRS_Sub = "FRS_Sub",
  // Payment Successful
  FRS_PSc = "FRS_PSc",
  // Payment Unsuccessful
  FRS_PUS = "FRS_PUS",
}

export enum FundingRequestClientStatusEnum {
  // Draft
  FRCS_Dr = "FRCS_Dr",
  // Request Revision,
  FRCS_RR = "FRCS_RR",
  // Awaiting Approval
  FRCS_AA = "FRCS_AA",
  // Rejected
  FRCS_Rj = "FRCS_Rj",
  // Approved
  FRCS_Ap = "FRCS_Ap",
}

export enum FundingRequestTypeEnum {
  // Standard
  FRT_St = "FRT_St",
  // Special
  FRT_Sp = "FRT_Sp",
}

export enum DonorTypeEnum {
  // Private Donor
  DT_P = "DT_P",
  // Business Donor
  DT_B = "DT_B",
}

export enum SortOrderEnum {
  Ascending = "Ascending",
  Descending = "Descending",
}

export enum JournalEntryTypeEnum {
  // Donor Payment
  JET_DP = "JET_DP",
  // Funding Request
  JET_FR = "JET_FR",
  // Intra-Account
  JET_IA = "JET_IA",
}

export enum AccountTypeEnum {
  // HAF General Account
  AT_G = "AT_G",
  // School Account
  AT_S = "AT_S",
}

export enum TransferDirectionEnum {
  // Transfer from School Account to HAF General Account
  TD_SchToHAFG = "TD_SchToHAFG",
  // Transfer from HAF General Account to School Account
  TD_HAFGToSch = "TD_HAFGToSch",
}

export enum SchoolOfficerRoleEnum {
  // Principal
  SOR_P = "SOR_P",
  // School HAF Admin
  SOR_A = "SOR_A",
  // School Staff
  SOR_S = "SOR_S",
  // Other
  SOR_O = "SOR_O",
}

export enum AdministratorRoleEnum {
  // System Administrator
  AR_Y = "AR_Y",
  // Head Administrator
  AR_H = "AR_H",
  // State Administrator
  AR_S = "AR_S",
}

export enum DonorRoleEnum {
  // Priivate Donor
  DT_P = "DT_P",
  // Business Donor
  DT_B = "DT_B",
}

export type UserRole =
  | AdministratorRoleEnum
  | SchoolOfficerRoleEnum
  | DonorRoleEnum;

export enum UserCategoryEnum {
  // Administrator
  UC_A = "UC_A",
  // School Officer
  UC_S = "UC_S",
  // Donor
  UC_D = "UC_D",
  // Committee Member
  UC_C = "UC_C",
}

export enum SchoolInvitationStatusEnum {
  // Invited
  SIS_I = "SIS_I",
  // Accepted
  SIS_A = "SIS_A",
  // Processed
  SIS_P = "SIS_P",
}

export enum PaymentFrequencyEnum {
  // Daily
  PF_D = "PF_D",
  // Weekly
  PF_W = "PF_W",
  // Fortnightly
  PF_F = "PF_F",
  // Monthly
  PF_M = "PF_M",
}

export enum SchedulePeriodEnum {
  // Minute
  SP_N = "SP_N",
  // Hourly
  SP_H = "SP_H",
  // Daily
  SP_D = "SP_D",
  // Weekly
  SP_W = "SP_W",
  // Monthly
  SP_M = "SP_M",
}

export enum ScheduledJobExecutionStateEnum {
  SJES_A = "SJES_A",
  SJES_P = "SJES_P",
}

export enum AddressTypeEnum {
  // Physical Address
  AT_Ph = "AT_Ph",
  // Postal Address
  AT_Po = "AT_Po",
}

export enum AdministrationPayerTypeEnum {
  // School Officer
  APT_SO = "APT_SO",
  // Committee Member
  APT_CM = "APT_CM",
}

export enum SchoolOfficerStatusEnum {
  // Invited
  SOS_I = "SOS_I",
  // Registered
  SOS_R = "SOS_R",
}
